<template>
  <validation-observer ref="providerObserver">
    <v-card outlined :loading="loading">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <LogoSelector v-model="settings.partner_logo" />
          </v-col>
          <v-col cols="12">
            <FontsSelector
              :title="$t('partners.details.settings.customization.font.title')"
              v-model="settings.font"
              :available-fonts="fonts"
            />
          </v-col>
          <v-col cols="12">
            <v-card flat>
              <v-card-subtitle class="pl-0 font-weight-bold">
                {{ $t('partners.details.settings.customization.themes.title') }}
              </v-card-subtitle>
              <v-card-text class="pl-0">
                <v-expansion-panels focusable v-model="panel">
                  <v-expansion-panel v-for="theme of themes" :key="theme">
                    <v-expansion-panel-header>
                      {{ $t(`partners.details.settings.customization.themes.${theme}`) }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row no-gutters>
                        <v-col cols="12" v-for="key of Object.keys(defaultThemes[theme])" :key="key">
                          <template v-if="key.includes('color')">
                            <ColorSelector
                              v-model="settings.theme[theme][key]"
                              :title="$t(`partners.details.settings.customization.themes.${key}`)"
                            />
                          </template>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </validation-observer>
</template>

<script>
  import { ValidationObserver } from 'vee-validate'
  import LogoSelector from '../inputs/LogoSelector.vue'
  import FontsSelector from '../inputs/FontsSelector.vue'
  import ColorSelector from '../inputs/ColorSelector.vue'
  import { defaultTheme } from '../../helpers/constante'
  import { textExists } from '../../helpers/helper'

  export default {
    name: 'PartnerSettingsCustomization',
    components: {
      LogoSelector,
      ValidationObserver,
      FontsSelector,
      ColorSelector,
    },
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        fonts: [
          { value: 'lato', text: 'Lato' },
          { value: 'source_sans_pro', text: 'Source Sans Pro' },
          { value: 'arial', text: 'Arial' },
          { value: 'helvetica', text: 'Helvetica' },
          { value: 'verdana', text: 'Verdana' },
          { value: 'tahoma', text: 'Tahoma' },
          { value: 'trebuchet_ms', text: 'Trebuchet MS' },
          { value: 'times_new_roman', text: 'Times New Roman' },
          { value: 'georgia', text: 'Georgia' },
          { value: 'courier_new', text: 'Courier New' },
          { value: 'lucida_console', text: 'Lucida Console' },
          { value: 'comic_sans_ms', text: 'Comic Sans MS' },
          { value: 'impact', text: 'Impact' },
        ],
        panel: 0, //first panel is open by default
      }
    },
    methods: {
      async hasErrors() {
        const valid = await this.$refs.providerObserver.validate()
        return !valid
      },
      textExists,
    },
    computed: {
      settings: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      themes() {
        return Object.keys(this.settings?.theme ?? {})
      },
      defaultThemes() {
        return structuredClone(defaultTheme.theme)
      },
    },
  }
</script>
